import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

function Hamburger({ isActive, toggle }) {
  function handleClick() {
    document.body.classList.toggle('is-overlaid')
    toggle()
  }

  return (
    <div
      className={classnames('hamburger js-track-link-click', isActive && 'is-active')}
      data-track-label="Mobile hamburger menu"
      data-track-text=""
      onClick={handleClick}
    >
      <div className="hamburger-box">
        <div className="hamburger-inner" />
      </div>
    </div>
  )
}

Hamburger.propTypes = {
  isActive: bool.isRequired,
  toggle: func.isRequired,
}

export default memo(Hamburger)
